import { Component, input } from '@angular/core';
import { ScrollPanelModule } from 'primeng/scrollpanel';

@Component({
  selector: 'pfx-scroll-panel',
  imports: [ScrollPanelModule],
  templateUrl: './scroll-panel.component.html',
})
export class ScrollPanelComponent {
  public height = input<string>('100%');
}
